export default Object.assign(CONFIG, window.STAC_BROWSER_CONFIG);
